import graphql from 'babel-plugin-relay/macro';

/**
 * Fragments
 */
export const COUNTRY_FRAGMENT = graphql`
  fragment countryFragment on Country @inline {
    name
    isoCodeTwo
    isoCodeThree
    continentName
    currency
    currencySymbol
  }
`;

export const COUNTRIES_FRAGMENT = graphql`
  fragment countryCountriesFragment on CountryEdge @relay(plural: true) {
    node {
      id
      name
      isoCodeTwo
      isoCodeThree
      continentName
      currency
      currencySymbol
      regions {
        id
        name
      }
    }
  }
`;

/**
 * Queries
 */
export const COUNTRIES_QUERY = graphql`
  query countryCountriesQuery($first: Int!, $after: String, $ordering: [CountryOrdering!], $filter: CountryFilter) {
    countries(first: $first, after: $after, ordering: $ordering, filter: $filter) {
      edges {
        ...countryCountriesFragment
      }
    }
  }
`;
export const COUNTRY_QUERY = graphql`
  query countryQuery($id: ID!, $skip: Boolean!) {
    country(id: $id) @skip(if: $skip) {
      ...countryFragment
    }
  }
`;
